export const LOAD_THANK_YOU_PAGE = 'LOAD_THANK_YOU_PAGE'
